/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'app.bsky.authManageModeration'

type $nsid = typeof $nsid

export { $nsid }

const main = /*#__PURE__*/ l.permissionSet(
  $nsid,
  [
    /*#__PURE__*/ l.permission('rpc', {
      inheritAud: true,
      lxm: [
        'app.bsky.actor.getPreferences',
        'app.bsky.actor.putPreferences',
        'app.bsky.graph.muteActor',
        'app.bsky.graph.muteActorList',
        'app.bsky.graph.muteThread',
        'app.bsky.graph.unmuteActor',
        'app.bsky.graph.unmuteActorList',
        'app.bsky.graph.unmuteThread',
      ],
    }),
    /*#__PURE__*/ l.permission('repo', {
      action: ['create', 'update', 'delete'],
      collection: ['app.bsky.graph.block', 'app.bsky.graph.listblock'],
    }),
  ],
  {
    title: 'Manage Personal Moderation',
    'title:lang': {},
    detail:
      'Control over blocks, mutes, mod lists, mod services, and preferences.',
    'detail:lang': {},
  },
)

export { main }
